import {useSelector} from 'react-redux';


import {configSelectors} from '../../Config';

import useGeoConfig from './useGeoConfig';


function useRegions() {

    // load to have it available
    useGeoConfig();

    return useSelector(configSelectors.getRegionHierarchy);
}


export default useRegions;
